import React from "react";

import { Box, Typography, Paper, Card, CardHeader, CardContent } from "@mui/material";

import { config, styles } from "../../style";

import "./style.css";

export const InnerCard = (props) => {
    const { title, children, subTitle, hideContent, action } = props;
    return (
        <Card className="InnerCard">
            <CardHeader
                sx={{
                    p: ".75rem",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#164C63",
                    borderBottom: "1px solid #ebecf0",
                    background: "#FAFAF6",
                }}
                title={title}
                subheader={subTitle}
                action={action}
                titleTypographyProps={{ component: "h3" }}
            ></CardHeader>
            {!hideContent && <CardContent>{children}</CardContent>}
        </Card>
    );
};
